// extracted by mini-css-extract-plugin
export default {"ribbon":"TableActionRibbon_ribbon__H4MR2","actions":"TableActionRibbon_actions__19U5H","sticky":"TableActionRibbon_sticky__mbcfx"};